import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "status"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Server Status", -1)

import { onBeforeMount, onBeforeUnmount, ref } from "vue";
import { CacheService } from "@/services/cache.service";
import { StatusModel } from "@/models/status.model";
import PlayerTable from "@/components/PlayerTable.vue";
import Loading from "@/components/Loading.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusView',
  setup(__props) {


const status = ref<StatusModel>();

function loadData() {
  CacheService.retrieveServerStatus()
    .then(rsp => status.value = rsp.data)
    .catch(e => console.log('Failed to retrieve online players'))
}

// retrieve data on mount
onBeforeMount(() => loadData())

// auto update data every 5 sec
const interval = setInterval(loadData, 5000)
onBeforeUnmount(() => clearInterval(interval));

return (_ctx: any,_cache: any) => {
  return (status.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h3", null, "Currently " + _toDisplayString(status.value.players.online) + " out of " + _toDisplayString(status.value.players.max) + " players online", 1),
        _createVNode(PlayerTable, {
          players: status.value.players.sample,
          "load-data": loadData
        }, null, 8, ["players"])
      ]))
    : (_openBlock(), _createBlock(Loading, { key: 1 }))
}
}

})